const FormItemType = Object.freeze({
  AUTOCOMPLETE: 'autocomplete',
  CALENDAR: 'calendar',
  CASCADESELECT: 'cascadeselect',
  CHECKBOX: 'checkbox',
  CHIPS: 'chips',
  COLORPICKER: 'colorpicker',
  DROPDOWN: 'dropdown',
  INPUTMASK: 'inputmask',
  INPUTNUMBER: 'inputnumber',
  INPUTSWITCH: 'inputswitch',
  INPUTTEXT: 'inputtext',
  KNOB: 'knob',
  MULTISELECT: 'multiselect',
  PASSWORD: 'password',
  RADIOBUTTON: 'radiobutton',
  RATING: 'rating',
  SELECTBUTTON: 'selectbutton',
  SLIDER: 'slider',
  TEXTAREA: 'textarea',
  TREESELECT: 'treeselect',
  TRISTATECHECKBOX: 'tristatecheckbox',
});

const FormMessageError = Object.freeze({
  FIELD_EMAIL: 'Formato de email no válido',
  FIELD_NIF: 'Formato de NIF no válido',
  FIELD_REQUIRED_EMAIL: 'Campo requerido o formato de email no válido',
  FIELD_REQUIRED_MIM_ROL: 'Campo requerido, mínimo un rol seleccionado',
  FIELD_REQUIRED_NIF: 'Campo requerido o formato de NIF no válido',
  FIELD_REQUIRED: 'Campo requerido',
  VALIDATION_TITLE: 'Error de validación',
  VALIDATION_ERROR: 'Error de validación',
  VALIDATION_UNCHANGED: 'Los campos no han cambiado',
  VALIDATION_UNEXPECTED: 'Ha ocurrido un error',
  VALIDATION_NOT_REGISTER_USER: 'No se ha podido registrar el usuario.',
  VALIDATION_NOT_UPDATE_STATE_USER: 'No se ha podido actualizar el estado del usuario.',
  VALIDATION_NOT_RESET_PASSWORD: 'No se ha podido restablecer la contraseña.',
});

const ToastTypes = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  WARN: 'warning',
  ERROR: 'danger',
});

export {
  FormMessageError,
  FormItemType,
  ToastTypes,
};
